(function(){
    var site_url = {
        "dev_FR" : "https://dev-champagne-telmont-fr.myshopify.com/",
        "dev_US" : "https://us-dev-champagne-telmont.myshopify.com/",
        "dev_JP" : "https://jp-dev-champagne-telmont.myshopify.com/",
        "stg_FR" : "https://telmont-staging-fr.myshopify.com/",
        "stg_US" : "https://telmont-staging-us.myshopify.com/",
        "stg_JP" : "https://telmont-staging-japan.myshopify.com/",
        "live_FR" : "https://fr.champagne-telmont.com/",
        "live_US" : "https://us.champagne-telmont.com/",
        "live_JP" : "https://jp.champagne-telmont.com/"
    };
    var stores = ["FR", "US", "JP"];
    var current_url = window.location.href;
    var staging_env = current_url.includes('staging'); 
    var dev_env = current_url.includes('dev'); 
    var env = "";
      
    if(staging_env){
        env += "stg_";
    }
    else if(dev_env){
        env += "dev_";
    }
    else{
        env += "live_";
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const country_choice = urlParams.get('c');
    if(country_choice && country_choice == 'INT'){
        setCookie("country_choice", true, 1);
    }
    if(getCookie("age_confirmation") !== "on" && getCookie("country_choice") != "true"){
        fetch('/browsing_context_suggestions.json')
        .then((resp) => resp.json())
        .then(function(data) {
            var countryCode = data.detected_values.country.handle;
            if(stores.includes(countryCode)){
                env += countryCode;
                window.location.href = site_url[env];
            }
        })
    }  

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "on";
    }

    function setCookie(cname, cvalue, exdays) {
        var dt = new Date();
        dt.setTime(dt.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + dt.toUTCString();
        var cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        document.cookie = cookie;
    }
})();